'use client';

import { useEffect } from 'react';

export function WebVitalsTracker() {
  useEffect(() => {
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout> | null = null;

    const loadWebVitals = async () => {
      if (cancelled) {
        return;
      }

      try {
        const { initWebVitals } = await import('@/lib/web-vitals');

        if (!cancelled) {
          initWebVitals();
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Web Vitals initialization failed:', error);
        }
      }
    };

    const scheduleLoad = () => {
      if (timer) {
        clearTimeout(timer);
      }

      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(() => {
          void loadWebVitals();
        });
        return;
      }

      timer = setTimeout(() => {
        void loadWebVitals();
      }, 1500);
    };

    if (document.readyState === 'complete') {
      scheduleLoad();
    } else {
      window.addEventListener('load', scheduleLoad, { once: true });
    }

    return () => {
      cancelled = true;

      if (timer) {
        clearTimeout(timer);
      }

      window.removeEventListener('load', scheduleLoad);
    };
  }, []);

  return null;
}
